import React from 'react'
import { useSelector } from 'react-redux'

import { helpLocation } from "slices/contextual_help"


const DEFAULT_HELP_LOCATION = "https://learn.adafruit.com/welcome-to-adafruit-io"

const UniversalHelpButton = () => {
  const
    specificHelpLink = useSelector(helpLocation),
    currentLink = specificHelpLink || DEFAULT_HELP_LOCATION

  return (
    <a className="btn rounded gray" target="_blank" href={ currentLink }>
      <i className="fas fa-circle-question"/> Help
    </a>
  )
}

export default UniversalHelpButton

